import { TextFieldVariants } from "@mui/material";
import SelectIdNameMultiple from "components/SelectIdNameMultiple";
import useLicenseFilterOptions from "hooks/useLicenseFilterOptions";
import { useIntl } from "react-intl";

type SelectLicensureBodyMultipleProps = {
  value: string[];
  onChange: (v: string[]) => void;
  variant?: TextFieldVariants;
  disabled?: boolean;
};

const SelectLicensureBodyMultiple = ({
  value,
  onChange,
  variant,
  disabled,
}: SelectLicensureBodyMultipleProps) => {
  const { formatMessage: t } = useIntl();
  const { data, isFetching } = useLicenseFilterOptions();

  return (
    <SelectIdNameMultiple
      label={t({ id: "licensureBody" })}
      options={data?.data?.licensureBodies ?? []}
      value={value}
      onChange={onChange}
      loading={isFetching}
      variant={variant}
      disabled={disabled}
    />
  );
};

export default SelectLicensureBodyMultiple;
